import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import { downloadFile } from 'app/utils/files';
import { apiRequestWithResponse } from 'app/utils/request/api';

import { ENDPOINTS } from '.';

export function useGetPaymentReceipt(bookingCode: string) {
  return useMutation({
    mutationFn: async () => {
      const response = await apiRequestWithResponse({
        path: ENDPOINTS.getPaymentReceipt,
        params: { bookingCode },
      });

      return response.blob();
    },
    onSuccess: (blob) => {
      downloadFile(blob, `receipt-${bookingCode}.pdf`);
    },
    onError: () => {
      message.error('Failed to download receipt');
    },
  });
}
